

jQuery( document ).ready(function(){
  if ( jQuery('#fundraiserBar').length) {
    console.log('Rendering Fundraiser Bar')
    OTUReact.renderView('AppFundraiserBar',{},document.getElementById('fundraiserBar'));
  
  }

})